import "./index.css";
import React, { Fragment, useRef } from "react";

export default function SingleFileUpload({
  label,
  updateState,
  logoPreview,
  setLogoPreview,
  hex,
  white,
  onDelete,
}) {
  const inputRef = useRef();

  const openFileBrowser = () => {
    inputRef.current && inputRef.current.click();
  };

  const updateMedia = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => setLogoPreview(reader.result);
      reader.onerror = () => console.error("Error reading file");

      reader.readAsDataURL(file);
      updateState(file);
    }
  };

  const onDeleteMedia = (e, media) => {
    e.stopPropagation();
    onDelete(media);
  };

  return (
    <Fragment>
      <label htmlFor="media" className="single-file-upload__label">
        {label}
      </label>
      <div className="single-file-upload__file-input">
        <button
          className={`btn btn-white btn-brand-hex ${
            logoPreview.length ? "single-file-upload--no-hover" : ""
          }`}
          onClick={openFileBrowser}
          disabled={logoPreview.length}
          style={{
            backgroundColor: hex || "white",
            color: white ? "white" : "black",
            "--hover-color": "white",
            "--hover-text-color": "black",
          }}
        >
          Choose file
        </button>
      </div>
      {logoPreview && (
        <div className="single-file-upload__container">
          <button
            className="single-file-upload__delete-button"
            title="Delete content"
            onClick={(e) => onDeleteMedia(e, logoPreview)}
          >
            <span className="single-file-upload__delete-icon">&times;</span>
          </button>
          <img
            src={logoPreview}
            alt="logo"
            className="single-file-upload__lead-media"
          />
        </div>
      )}
      <input
        style={{ display: "none" }}
        name="media"
        id="media"
        ref={inputRef}
        accept="image/*"
        type="file"
        className="form-control form-control-md form-control-alt brand-registered-input"
        onChange={updateMedia}
      />
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/screens/ProductPortfolio/components/SingleFileUpload/index.js